export default __webpack_public_path__ + "static/media/kasparov.2ac9ba61.txt";